import React, { PropTypes, Component } from 'react';
import { connectToStores } from 'fluxible/addons';
import Profile from '../components/Profile';

class UserProfilePage extends Component {
  static propTypes = {
    profile: PropTypes.array.isRequired
  }

  static defaultProps = {
    profile: []
  }

  render() {
    const profile = this.props.profile;
    return (
      <Profile data={ profile } />
      );
  }
}

UserProfilePage = connectToStores(UserProfilePage, ['UserProfileStore'], (stores, props) => {
  return {
    profile: stores.UserProfileStore.get()
  };
});

export default UserProfilePage;


// WEBPACK FOOTER //
// ./src/pages/UserProfilePage.js